import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SUPPORTED = ["fr", "de", "en", "it", "pt", "es"];

/**
 * Returns a function that prefixes paths with the user's preferred language.
 * Priority: i18n.language > URL param > "fr".
 * This ensures internal navigation respects the user's language choice
 * (manual or auto-detected) rather than the lang segment of the current URL.
 */
export const useLocalizedPath = () => {
  const { lang: urlLang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();

  const i18nLang = i18n.language?.toLowerCase().split("-")[0];
  const preferred =
    (i18nLang && SUPPORTED.includes(i18nLang) && i18nLang) ||
    (urlLang && SUPPORTED.includes(urlLang) && urlLang) ||
    "fr";

  return (path: string) => `/${preferred}${path === "/" ? "" : path}`;
};
